import { initAdv, injectAdv, shouldInjectAdv } from '@sky-uk/sky-adv';

import { initAdvLabels } from '../../utils/adv-helper';
import { forEach } from '../../utils/array-utils';
import { isGalleryPage } from '../../utils/aem-utils';
import { insertAfter } from '../../utils/dom-utils';

const injectAdvTopBottom = ($advDataNode, advObserver) => {
  console.info('[ADV TOP BOTTOM] init adv');
  const $advContainer = document.createElement('div');
  insertAfter($advDataNode, $advContainer);
  injectAdv($advDataNode, $advContainer);

  const initAdvCallback = () => {
    advObserver?.unobserve($advDataNode);
  };
  initAdv($advDataNode, initAdvCallback);
};

/**
 * When the adv container is in view --> inject the single adv
 * @param {Object} observerEntries of the IntersectionObserver
 * @param {IntersectionObserver} advObserver
 */
const injectAdvTopBottomLazy = (observerEntries, advObserver) => {
  forEach((observerEntry) => {
    const advIsIntersecting = observerEntry.isIntersecting;
    const $advDataNode = observerEntry.target;
    if (advIsIntersecting && shouldInjectAdv($advDataNode)) {
      injectAdvTopBottom($advDataNode, advObserver);
    }
  })(observerEntries);
};

/**
 * When the page has been loaded (window.onload) --> inject all the adv's
 * NOTE: in a gallery page just inject the adv-bottom. The others will be injected by the lazy method
 * @param {HTML Nodelist} $advAllDataNodes
 * @param {HTML Nodelist} $advBottomDataNodes
 * @param {IntersectionObserver} advObserver
 */
const injectOnPageLoadedAdv = ({ $advAllDataNodes, $advBottomDataNodes, advObserver }) => {
  if (isGalleryPage()) {
    const $advBottomDataNode = $advBottomDataNodes[0];
    if (shouldInjectAdv($advBottomDataNode)) {
      injectAdvTopBottom($advBottomDataNode, advObserver);
    }
  } else {
    forEach(($advDataNode) => {
      if (shouldInjectAdv($advDataNode)) {
        injectAdvTopBottom($advDataNode, advObserver);
      }
    })($advAllDataNodes);
  }
};

export const init = ({ $advTopDataNodes, $advBottomDataNodes }) => {
  initAdvLabels();

  const advObserverOptions = {
    rootMargin: '0px 0px 300px 0px',
    threshold: 0.1,
  };
  const advObserver = new IntersectionObserver(injectAdvTopBottomLazy, advObserverOptions);

  // Lazy adv inject
  const $advAllDataNodes = [...$advTopDataNodes, ...$advBottomDataNodes];
  forEach(($advDataNode) => {
    advObserver.observe($advDataNode);
  })($advAllDataNodes);

  // On-window-loaded adv inject
  window.addEventListener('load', () => injectOnPageLoadedAdv({ $advAllDataNodes, $advBottomDataNodes, advObserver }));
};
